import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { RenameFolderDto } from '../../types/vault.types';
import { useIdempotentAppMutation } from '../use-idempotent-app-mutation.hook';

export const useRenameFolder = () => {
  const { mutate: renameFolder, isPending } = useIdempotentAppMutation([QueryKey.RENAME_FOLDER], {
    mutationFn: (
      {
        companyId,
        data,
        folderId,
      }: {
        companyId: string;
        data: RenameFolderDto;
        folderId: string;
      },
      { headers },
    ) =>
      ApiService.patch(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'vault', 'folders', folderId] },
        {
          body: data,
          headers,
        },
      ),
  });
  return { renameFolder, isPending };
};
